import { useQuery } from '@tanstack/react-query'

import { getEnrollmentsPickupListCount } from '../../api/centers/get-enrollments-pickup-list-count'

// Youth eligible for the "Liste personne désignée au retour - voyages indiv" printout: France stay,
// no LEC transport. Drives the greyed-out state of the print CTA.
export const useEnrollmentsPickupListCount = (centerId?: number, enabled = true) => {
  const { data, isPending } = useQuery({
    queryKey: ['enrollments-pickup-list-count', centerId],
    queryFn: () => getEnrollmentsPickupListCount(centerId as number),
    enabled: enabled && !!centerId
  })

  const count = data?.count ?? 0
  return { count, hasCandidates: count > 0, isPending }
}
